import { useMediaQuery } from 'react-responsive';
import { MOBILE_BREAKPOINT } from '../../constants/values';

function UseIsMobile() {
    return useMediaQuery({ query: `(max-device-width: ${MOBILE_BREAKPOINT}px)` });
}

export default UseIsMobile;
